import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", null, "From", -1 /* HOISTED */);
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", null, "To", -1 /* HOISTED */);
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_13 = { class: "checkbox-wrapper" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_15 = { class: "checkbox-wrapper" };
const _hoisted_16 = { class: "float-end float-start-sm" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_MonthYearPickerVue = _resolveComponent("MonthYearPickerVue");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _createTextVNode("Editing schedule report "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select a company",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All sites",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(),
            _createVNode(_component_MonthYearPickerVue, {
                modelValue: _ctx.fromDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.fromDate) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(),
            _createVNode(_component_MonthYearPickerVue, {
                modelValue: _ctx.toDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.toDate) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _createTextVNode(),
        _createCommentVNode("Hidden for version 1.9"),
        _createTextVNode(),
        _createCommentVNode("<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\t\t<label>Alarm Detection Method</label>\r\n\t\t<div class=\"input-group top_search\">\r\n\t\t\t<multiselect v-model=\"selectedAlarmStrategy\" :options=\"alarmStrategies\" track-by=\"value\" label=\"text\" :showLabels=\"false\" :allowEmpty=\"false\" placeholder=\"Select alarm detection method\" class=\"multiselect-small\">\r\n\t\t\t\t<template #noResult>\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t</template>\r\n\t\t\t</multiselect>\r\n\t\t</div>\r\n\t</div>"),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.groupBySite,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.groupBySite) = $event)),
                    size: "lg"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\tGroup by Site\r\n\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.groupByCategory,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.groupByCategory) = $event)),
                    size: "lg"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode("\r\n\t\t\t\tGroup by Category\r\n\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_16, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _createTextVNode(),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.generateSummaryStatusReport
            }, {
                default: _withCtx(() => [
                    _hoisted_18,
                    _createTextVNode(" Export PDF\r\n\t\t")
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
